import { NAR, RAT, REC, REP_IMG } from "../../../../shared/Data/typeDirs";
import { CategorySelector } from "./categorySelector";
import { Container } from "./container";
import { ImageControl } from "./image";
import { MarkdownControl } from "./markdown";
import { MultiSelect } from "./multiselect";
import { NarrativeControl } from "./narratives";
import { RatingsControl } from "./rating";
import { RecommendationsControl } from "./recommendations";
import { ReportImagesControl } from "./report_images";
import { TextControl } from "./text";
import { Dropdown } from "./dropdown";
import '../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/index.css'
import { MultiPicker } from "./multipicker";
import { AddressControl } from "./address";
import { ReportBlockUtilities } from "./reportBlockUtilities";
import { ChatControl } from "./chat";
import { ExportCategories } from "./exportCategories";
import { ExportNarratives } from "./exportNarratives";
import { ExportFrontMatter } from "./exportFrontMatter";
import { ExportTableOfContents } from "./exportTableOfContents";

const Theme = {
  Container,
  MultiSelect,
  image: ImageControl,
  text: TextControl,
  [NAR]: NarrativeControl,
  [REC]: RecommendationsControl,
  [REP_IMG]: ReportImagesControl,
  categorySelector:CategorySelector,
  markdown:MarkdownControl,
  [RAT]: RatingsControl,
  dropdown:Dropdown,
  multipicker:MultiPicker,
  address:AddressControl,
  reportBlockUtilities: ReportBlockUtilities,
  chat: ChatControl,
  exportCategories:ExportCategories,
  exportNarratives: ExportNarratives,
  exportFrontMatter: ExportFrontMatter,
  exportTableOfContents : ExportTableOfContents
}

export { MultiSelect, Container, Theme}